import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    // Avoid double-init
    if (window.fbq) return

    const f: any = function (...args: any[]) {
      f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args)
    }
    if (!window._fbq) window._fbq = f
    window.fbq = f
    f.push = f
    f.loaded = true
    f.version = '2.0'
    f.queue = []

    // Load the SDK script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    // Init pixel
    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')

    // Noscript fallback pixel
    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    return () => {
      script.remove()
      noscript.remove()
    }
  }, [pixelId])
}
